(function(){'use strict';
var KEY='bpb_recent_product_handles_v1';

function read(){
  try{
    var value=JSON.parse(localStorage.getItem(KEY)||'[]');
    if(!Array.isArray(value))return[];
    return value.filter(function(handle,index,list){return typeof handle==='string'&&handle&&list.indexOf(handle)===index});
  }catch(e){return[]}
}
function write(list){
  try{
    var clean=(list||[]).filter(function(handle,index,items){return typeof handle==='string'&&handle&&items.indexOf(handle)===index});
    localStorage.setItem(KEY,JSON.stringify(clean.slice(0,10)));
  }catch(e){}
}
function money(cents,currency){
  var value=(Number(cents)||0)/100;
  try{
    return new Intl.NumberFormat('en-IN',{style:'currency',currency:currency||'INR',minimumFractionDigits:0,maximumFractionDigits:2}).format(value);
  }catch(e){
    return 'Rs. '+value.toFixed(2);
  }
}
function factsFor(root,handle){
  return fetch(root+'/products/'+encodeURIComponent(handle),{credentials:'same-origin'})
    .then(function(response){if(!response.ok)throw new Error('facts');return response.text()})
    .then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var node=doc.querySelector('[data-bpb-product-facts-json]');
      if(!node)return{};
      try{return JSON.parse(node.textContent||'{}')}catch(e){return{}}
    })
    .catch(function(){return{}});
}
function makeFact(label,modifier){
  var fact=document.createElement('span');
  fact.className='bpb-recent-card__fact bpb-recent-card__fact--'+modifier;
  fact.textContent=label;
  return fact;
}
function card(product,currency,facts){
  var url=product.url||'#';
  var titleText=product.title||'Product';

  var item=document.createElement('article');
  item.className='bpb-recent-card';

  var media=document.createElement('a');
  media.className='bpb-recent-card__media';
  media.href=url;
  media.setAttribute('aria-label','View '+titleText);

  if(product.featured_image){
    var img=document.createElement('img');
    img.src=product.featured_image;
    img.loading='lazy';
    img.alt=titleText;
    media.appendChild(img);
  }

  var body=document.createElement('div');
  body.className='bpb-recent-card__body';

  var title=document.createElement('h3');
  title.className='bpb-recent-card__title';
  var titleLink=document.createElement('a');
  titleLink.href=url;
  titleLink.textContent=titleText;
  title.appendChild(titleLink);

  var price=document.createElement('div');
  price.className='bpb-recent-card__price';
  var current=document.createElement('strong');
  current.textContent=money(product.price,currency);
  price.appendChild(current);
  if(Number(product.compare_at_price)>Number(product.price)){
    var compare=document.createElement('del');
    compare.className='bpb-recent-card__compare';
    compare.textContent=money(product.compare_at_price,currency);
    price.appendChild(compare);
  }

  body.appendChild(title);
  body.appendChild(price);

  if((facts&&facts.ink)||(facts&&facts.refill)){
    var factsWrap=document.createElement('div');
    factsWrap.className='bpb-recent-card__facts';
    factsWrap.setAttribute('aria-label','Product details');
    if(facts&&facts.ink)factsWrap.appendChild(makeFact(facts.ink,'ink'));
    if(facts&&facts.refill)factsWrap.appendChild(makeFact('Refill: '+facts.refill,'refill'));
    body.appendChild(factsWrap);
  }

  var cta=document.createElement('a');
  cta.className='bpb-recent-card__cta';
  cta.href=url;
  cta.textContent='View Pen';
  cta.setAttribute('aria-label','View '+titleText);
  body.appendChild(cta);

  item.appendChild(media);
  item.appendChild(body);
  return item;
}
function initSection(section){
  if(!section||section.dataset.bpbRecentBound==='true')return;
  section.dataset.bpbRecentBound='true';

  var current=section.getAttribute('data-current-handle')||'';
  var limit=Math.max(1,parseInt(section.getAttribute('data-limit'),10)||4);
  var root=(section.getAttribute('data-root')||'/').replace(/\/$/,'');
  var currency=section.getAttribute('data-currency')||'INR';
  var grid=section.querySelector('[data-bpb-recent-grid]');
  var stored=read().filter(function(handle){return handle&&handle!==current});
  var targets=stored.slice(0,limit);

  if(current)write([current].concat(stored));
  if(!grid||!targets.length)return;

  Promise.all(targets.map(function(handle){
    var productRequest=fetch(root+'/products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'})
      .then(function(response){if(!response.ok)throw new Error('product');return response.json()})
      .catch(function(){return null});
    return Promise.all([productRequest,factsFor(root,handle)])
      .then(function(pair){return{product:pair[0],facts:pair[1]}});
  })).then(function(rows){
    rows.forEach(function(row){
      if(row.product)grid.appendChild(card(row.product,currency,row.facts));
    });
    if(grid.children.length)section.hidden=false;
  }).catch(function(){});
}
function init(){document.querySelectorAll('[data-bpb-recent]').forEach(initSection)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();